import { IoC } from '../../ServicesContainer';
import {
    ISharepointDataService,
    SharepointDataServiceName,
} from '../../../DataServices/SharepointDataService';
import { BaseReduxService } from '../Api/BaseReduxService';
import { Lazy } from '../../../Helpers/Lazy';
import { II18nService, I18nServiceName } from '../I18n/I18nService';
import { XHRRequestCanceler } from '../../../../Libs/xhr/XHRRequestCanceler';
import { SharepointResponse } from '../../../Models/Sharepoint/Sharepoint';
import { UrlUtils } from '../../../Utils/UrlUtils';

export interface ISharepointService {
    verifySharepoint: (
        requestParams: {
            url?: string;
        },
        cts: XHRRequestCanceler
    ) => Promise<SharepointResponse>;
}

class SharepointService extends BaseReduxService implements ISharepointService {
    private readonly sharepointDataService: Lazy<ISharepointDataService>;
    private readonly i18nService: Lazy<II18nService>;

    constructor() {
        super();
        this.sharepointDataService = new Lazy(() =>
            IoC.get<ISharepointDataService>(SharepointDataServiceName)
        );

        this.i18nService = new Lazy<II18nService>(() => IoC.get<II18nService>(I18nServiceName));
    }

    public verifySharepoint = async (
        requestParams: {
            url?: string;
        },
        cts: XHRRequestCanceler
    ) => {
        try {
            const encodedUrl: string = UrlUtils.base64urlUnpadded_encode(requestParams.url || '');
            const response = await this.sharepointDataService
                .value()
                .verifySharepoint({ url: encodedUrl }, cts);
            return Promise.resolve(response);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

const SharepointServiceName = 'SharepointService';
export { SharepointService, SharepointServiceName };
